import React from "react";

const Stories = () => {
  return (
    <section className="bg-light text-dark" style={{ padding: "100px 0px" }}>
      <div className="container position-relative solution">
        <div className="row align-items-center g-5">
          {/* Left: Text */}
          <div className="col-lg-6 col-md-6">
            <h2 className="text-dark">
              The Ultimate Solution for Effortless Online Business
            </h2>
            <p className="mt-3">
              Say goodbye to server headaches. Fexila streamlines everything you
              need to manage your eCommerce business—without the complexity.
            </p>
            <ul className="benefits" style={{ listStyle: "none", padding: 0 }}>
              <li className="d-flex align-items-center mb-3">
                <span className="check-icon me-3">✓</span>
                <span>
                  Create products, categories, coupons, shipments, and more.
                </span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <span className="check-icon me-3">✓</span>
                <span>
                  Automate customer engagement with email campaigns and
                  promotions.
                </span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <span className="check-icon me-3">✓</span>
                <span>
                  Customize invoice and email templates to match your brand.
                </span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <span className="check-icon me-3">✓</span>
                <span>
                  Update your store name, branding, and go live in minutes.
                </span>
              </li>
              <li className="d-flex align-items-center mb-3">
                <span className="check-icon me-3">✓</span>
                <span>
                  Manage everything from our intuitive, all-in-one dashboard.
                </span>
              </li>
            </ul>
          </div>

          {/* Right: Images */}
          <div className="col-lg-6 col-md-6 position-relative">
            <img
              src="assets/images/analytics.png"
              alt="Dashboard Preview"
              className="img-fluid shadow-lg analytics"
              style={{
                borderRadius: "25px",
                marginTop: "-139px",
              }}
            />
            <img
              src="assets/images/twitter.png"
              alt="Twitter Preview"
              className="img-fluid shadow-lg twitter"
              style={{
                borderRadius: "25px",
                marginTop: "-100px",
                marginLeft: "-54px",
              }}
              width="175px"
            />
            <img
              src="assets/images/facebook.png"
              alt="Facebook Preview"
              className="img-fluid shadow-lg facebook"
              style={{
                borderRadius: "25px",
                marginTop: "-477px",
                marginLeft: "391px",
              }}
              width="175px"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stories;
